export default defineNuxtRouteMiddleware((to) => {
  const referralCode = Array.isArray(to?.query?.ref)
    ? to.query.ref[0]
    : to?.query?.ref
  
  const endorselyReferral = Array.isArray(to?.query?.via)
    ? to.query.via[0]
    : to?.query?.via
  
  const referralCookie = useCookie('referralCode', {
    maxAge: 60 * 60 * 24 // time in seconds (24 hours)
  })

  if (referralCode) {
    referralCookie.value = referralCode
  } else if (endorselyReferral) {
    referralCookie.value = endorselyReferral
  }
})
